import { getMoney, getTotalWeekdays } from "./helperFunctions";

export const getJobTotalHours = (jobData = {}) => {
  const totalLength = Number(jobData.totalLength) || 0;
  if (totalLength > 0) return totalLength / 3600000;
  return getTotalWeekdays(jobData.startAt, jobData.endAt) * 8;
};

export const getFeeMatrixForWorkplace = ({
  baseJobFeeAmount,
  workplaceId,
  feeConfigs,
  totalHours = 160,
  hourlySuffix,
}) => {
  const staffingCompanyFeeData =
    feeConfigs[workplaceId] ?? feeConfigs["default"] ?? 0;
  const displayCompensations =
    staffingCompanyFeeData?.displayCompensations ?? false;

  const feeRange = staffingCompanyFeeData["feeRange"] ?? {
    min: 80,
    max: 95,
  };
  const feeRangeMin = feeRange["min"] ?? 80;
  const feeRangeMax = feeRange["max"] ?? 95;

  // Staffing company's fee = (100 - fee range value) × base job fee amount / 100
  const staffingCompanyFeeMin = Math.ceil(
    ((100 - feeRangeMax) * baseJobFeeAmount) / 100,
  );
  const staffingCompanyFeeMax = Math.ceil(
    ((100 - feeRangeMin) * baseJobFeeAmount) / 100,
  );

  // Compensation = base job fee - staffing company fee
  const compensationFeeMin = Math.ceil(
    baseJobFeeAmount - staffingCompanyFeeMax,
  );
  const compensationFeeMax = Math.ceil(
    baseJobFeeAmount - staffingCompanyFeeMin,
  );

  const medianFeeValue = (compensationFeeMin + compensationFeeMax) / 2;
  const feeEqual = compensationFeeMin === compensationFeeMax;

  const compensationFeeText = feeEqual
    ? `${getMoney(compensationFeeMin)} ${hourlySuffix ?? "per timme"}`
    : `${getMoney(compensationFeeMin)} - ${getMoney(compensationFeeMax)} ${hourlySuffix ?? "per timme"}`;

  const canDisplayCompensation =
    (displayCompensations && baseJobFeeAmount > 0) ||
    (compensationFeeMin > 0 && compensationFeeMax > 0);

  const salary = canDisplayCompensation ? `${compensationFeeText}` : "";

  const monthlyMinValue = compensationFeeMin * totalHours;
  const monthlyMaxValue = compensationFeeMax * totalHours;

  const { textColor, bgColor } = (() => {
    if (medianFeeValue <= 999) {
      return {
        textColor: "#ffffff",
        bgColor: "#86efac",
      };
    } else if (medianFeeValue <= 1300) {
      return {
        textColor: "#ffffff",
        bgColor: "#22c55e",
      };
    } else if (medianFeeValue <= 1550) {
      return {
        textColor: "#ffffff",
        bgColor: "#1e40af",
      };
    } else {
      return {
        textColor: "#ffffff",
        bgColor: "#0f172a",
      };
    }
  })();

  return {
    canDisplayCompensation: canDisplayCompensation,
    text: salary,
    compensationFeeMin: Math.min(compensationFeeMin, compensationFeeMax),
    compensationFeeMax: Math.max(compensationFeeMin, compensationFeeMax),
    staffingCompanyFeeMin: staffingCompanyFeeMin,
    staffingCompanyFeeMax: staffingCompanyFeeMax,
    jobCompensationText: getMoney(baseJobFeeAmount),
    medianFeeValue: medianFeeValue,
    monthlyMinValue: monthlyMinValue,
    monthlyMaxValue: monthlyMaxValue,
    textColor: textColor,
    bgColor: bgColor,
  };
};
